import createBottomComponent from "../../../../helpers/common/CoreInputText/components/Bottom/fabric";
import { SEARCH_DISPLAY_NAME } from "../../utils/core";

export const Component = createBottomComponent(SEARCH_DISPLAY_NAME);
